export const CALENDAR_DETAIL = "calendar_detail";
export const CHANNEL_DETAIL = "channel_detail";
export const CHANNEL_DETAIL_ACTUAL_SPEND = "channel_detail_actual_spend";
export const CALENDAR_DATE_DETAILS = "calendar_date_details";